import { render, staticRenderFns } from "./GoenrollFooter.vue?vue&type=template&id=58ecaf3e"
import script from "./GoenrollFooter.vue?vue&type=script&lang=js"
export * from "./GoenrollFooter.vue?vue&type=script&lang=js"
import style0 from "./GoenrollFooter.vue?vue&type=style&index=0&id=58ecaf3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports